import React, { Component, PropTypes } from 'react';
import { Redirect } from 'react-router-dom';
import LoginForm from './login-form.js';
import { sessionKey } from './../store/cookies.js';

class Login extends Component {
	render() {
		const { from } = this.props.location.state || { from: { pathname: '/' } };

		if (sessionKey()) {
			return (
				<Redirect to={from} />
			)
		}
		return (
			<LoginForm />
		);
	}
}

export default Login;



// WEBPACK FOOTER //
// ./mobile-core/src/components/login.js